import { useEffect, useState } from "react";
import JobAssignmentService from "../services/JobAssignmentService";
import { usePermissions } from "./usePermissions";

/** Fail closed: expose assignment only after an enabled backend setting is received. */
export default function useAdminAssignmentEnabled(): boolean {
  const { canEditJob, userProfile } = usePermissions();
  const allowed = canEditJob();
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    if (!allowed) { setEnabled(false); return; }
    setEnabled(false);
    let controller: AbortController | undefined;
    const check = () => {
      controller?.abort(); controller = new AbortController();
      const signal = controller.signal;
      JobAssignmentService.enabled(signal).then(value => { if (!signal.aborted) setEnabled(value); })
        .catch(() => { if (!signal.aborted) setEnabled(false); });
    };
    check(); window.addEventListener("focus", check);
    return () => { controller?.abort(); window.removeEventListener("focus", check); };
  }, [allowed, userProfile?.id]);
  return allowed && enabled;
}
